const observerConfig = {
  childList: true,
  subtree: true,
}

let observer = new MutationObserver(mutations => {
  for (let mutation of mutations) {
    for (let node of mutation.addedNodes) {
      if (!(node instanceof HTMLElement)) continue;

      if (node.classList.contains('.labels') || node.querySelector('.labels')) {
        let element = node.classList.contains('.labels') ? node : node.querySelector('.labels');
        window.initLabels(element)
      }
      // if (node.classList.contains('select') || node.querySelector('.select')) {
      //     let jqSelector = $(node.querySelector('.jsSelect'));
      //     window.initSelect(jqSelector)
      // }

      if (node.hasAttribute('data-bs-toggle', 'tooltip') || node.querySelector('[data-bs-toggle="tooltip"]')) {
        let element = node.hasAttribute('data-bs-toggle', 'tooltip') ? node : node.querySelector('[data-bs-toggle="tooltip"]');
        window.initTooltip(element)
      }
    }
  }
});

document.addEventListener('DOMContentLoaded', () => {
  observer.observe(document.querySelector('body'), observerConfig);
})
